import { Swiper, SwiperSlide } from 'swiper/react';
import { useMedia } from '../../media.context';
import { MediaFile } from './media-file';
import { StyledThumbnail } from './styles';

export const ThumbnailCarousel = () => {
  const { files, previewer } = useMedia();

  return (
    <Swiper
      initialSlide={previewer.openedIndex ?? 0}
      onSwiper={previewer.attachThumbsSwiper}
      slidesPerView="auto"
      centeredSlides
      grabCursor
      spaceBetween={8}
      style={{
        margin: -10,
        padding: 10,
        width: '100%',
      }}
    >
      {files.map((file, index) => (
        <SwiperSlide
          key={file.id}
          style={{
            width: previewer.openedIndex === index ? 114 : 64,
            height: 64,
            transition: 'width 200ms ease',
          }}
        >
          <StyledThumbnail
            $selected={previewer.openedIndex === index}
            onClick={() => {
              previewer.goTo(index);
            }}
          >
            <MediaFile file={file} view="thumbnail" />
          </StyledThumbnail>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
